import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export default function SocialMedia() {
  const location = useLocation();
  const scrollRef = useRef();

  useEffect(() => {
    const arrow = document.getElementById('next-video-arrow');
    if (arrow) {
      arrow.style.color = 'white'; 
    }
  }, []);

  if (location.pathname === '/login') return null;
  
  const videos = [
    "https://www.youtube.com/embed/osQo5m7P0Zo?si=ciYjlSj5Y_ktgxQ-",
    "https://www.youtube.com/embed/U3YigUmo-gk?si=l9LTYYQi3vJtSSD3",
    "https://www.youtube.com/embed/thcJcSUZs9I?si=s6yHP_FT7QltRJov",
    "https://www.youtube.com/embed/HcqP5e49qEc",
    "https://www.youtube.com/embed/SgcMglFFeRA",
    "https://www.youtube.com/embed/cX8vI_r5Ekc?s",
    "https://www.youtube.com/embed/kBvSdaxfAas?s",
    "https://www.youtube.com/embed/EOHxyr16IJs",
    "https://www.youtube.com/embed/AnxJlgv0ozk?si",
    "https://www.youtube.com/embed/SHBAtTGPHPU",
    "https://www.youtube.com/embed/Yq26-LvQuEs",
    "https://www.youtube.com/embed/RrQnJ255XeE",
    "https://www.youtube.com/embed/xiPUnyE1joI",
    "https://www.youtube.com/embed/7ZsUPelnxVY"
  ];
  

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -320, behavior: 'smooth' });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 320, behavior: 'smooth' });
  };

  return (
    <div className="position-relative my-4">
      <button
        onClick={scrollLeft}
        className="btn btn-dark position-absolute top-50 start-0 translate-middle-y"
        style={{ zIndex: 2 }}
      >
        <i className="fas fa-chevron-left"></i>
      </button>

      <div
        id="social-media-container"
        ref={scrollRef}
        className="social-media container-fluid px-0 d-flex flex-nowrap overflow-auto"
        style={{ scrollBehavior: 'smooth' }}
      >
        {videos.map((video, index) => (
          <div key={index} className="video-frame mx-2 flex-shrink-0">
            <iframe
              className="rounded shadow"
              width="300"
              height="180"
              src={video}
              title={`Video ${index + 1}`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>
        ))}
      </div>

      <button
        onClick={scrollRight}
        className="btn btn-dark position-absolute top-50 end-0 translate-middle-y"
        style={{ zIndex: 2 }}
      >
        <i id="next-video-arrow" className="fas fa-chevron-right"></i>
      </button>
    </div>
  );
}
